
import store from '@/store/index'

/**
 * 登录，退出操作
 * 
 **/
const perms = {
    state: {
       perms: false,//判断是否刷新过页面,
    },
    mutations: {
    	 SET_PERMS: (state, params) => {
            state.perms = params;
        }
    },
    actions: {
    	setPerms({ commit }, obj) {
            commit('SET_PERMS', obj)
        }
    }
};
export default perms;